import { Injectable, ErrorHandler } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { IApiError } from '../../interface';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import * as StackTraceParser from 'error-stack-parser';


// Our service to handle errors (ideally in its own file)
@Injectable()
export class ErrorLogService {

  private _updateHttpError: BehaviorSubject<IApiError> = new BehaviorSubject<IApiError>({
    code: 0,
    description: '',
    message: '',
    trace: ''
  });

  update$: Observable<IApiError> = this._updateHttpError.asObservable();

  logError(error: any) {
    if (error instanceof HttpErrorResponse) {
      this._updateHttpError.next({
        code: (<HttpErrorResponse>error).status,
        description: `There was an HTTP error., ${error.message}, Status code:, ${(<HttpErrorResponse>error).status}`,
        message: error.message,
        trace: error.error
      });
    }
    else if (error instanceof TypeError) {
      console.log(error.stack);

      this._updateHttpError.next({
        code: 6000.01,
        description: `There was a Type error. ${error.message}`,
        message: error.message,
        trace: error.stack
      });
    }
    else if (error instanceof Error) {
      this._updateHttpError.next({
        code: 6000.02,
        description: `There was a general error. ${error.message}`,
        message: error.message,
        trace: error.stack
      });
    } else {
      this._updateHttpError.next({
        code: 6000.00,
        description: `Nobody threw an error but something happened!. ${error}`,
        message: error,
        trace: ''
      });
    }
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/services/error/error.service.ts